/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetBasicBbsContentPageListRespVo } from './GetBasicBbsContentPageListRespVo';
import {
    GetBasicBbsContentPageListRespVoFromJSON,
    GetBasicBbsContentPageListRespVoFromJSONTyped,
    GetBasicBbsContentPageListRespVoToJSON,
    GetBasicBbsContentPageListRespVoToJSONTyped,
} from './GetBasicBbsContentPageListRespVo';

/**
 * 
 * @export
 * @interface GetBbsContentGroupByCategoryRespVo
 */
export interface GetBbsContentGroupByCategoryRespVo {
    /**
     * 分类ID
     * @type {number}
     * @memberof GetBbsContentGroupByCategoryRespVo
     */
    categoryId?: number;
    /**
     * 该分类下的内容列表
     * @type {Array<GetBasicBbsContentPageListRespVo>}
     * @memberof GetBbsContentGroupByCategoryRespVo
     */
    contentList?: Array<GetBasicBbsContentPageListRespVo>;
}

/**
 * Check if a given object implements the GetBbsContentGroupByCategoryRespVo interface.
 */
export function instanceOfGetBbsContentGroupByCategoryRespVo(value: object): value is GetBbsContentGroupByCategoryRespVo {
    return true;
}

export function GetBbsContentGroupByCategoryRespVoFromJSON(json: any): GetBbsContentGroupByCategoryRespVo {
    return GetBbsContentGroupByCategoryRespVoFromJSONTyped(json, false);
}

export function GetBbsContentGroupByCategoryRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBbsContentGroupByCategoryRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'contentList': json['contentList'] == null ? undefined : ((json['contentList'] as Array<any>).map(GetBasicBbsContentPageListRespVoFromJSON)),
    };
}

export function GetBbsContentGroupByCategoryRespVoToJSON(json: any): GetBbsContentGroupByCategoryRespVo {
    return GetBbsContentGroupByCategoryRespVoToJSONTyped(json, false);
}

export function GetBbsContentGroupByCategoryRespVoToJSONTyped(value?: GetBbsContentGroupByCategoryRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'categoryId': value['categoryId'],
        'contentList': value['contentList'] == null ? undefined : ((value['contentList'] as Array<any>).map(GetBasicBbsContentPageListRespVoToJSON)),
    };
}

